import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {BaseAuthorizationProfile} from '../types';

const getAuthorizationProfilesResponseMock: BaseAuthorizationProfile[] = [
  {
    id: '55041578-ed1d-11ee-a951-0242ac120002',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '1f3d02fd-99dc-462f-9c12-9c5dd631cfa5',
    authorizationId: '9c493262-e7b6-4e59-813c-7f2ab14030ed',
    name: 'Other',
    isActive: false,
    isDefault: false,
    companyId: '7aafd041-f024-4550-876a-7b1bab2ff50c',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
  },
  {
    id: 'babda298-3ff3-49bf-9b12-ab21ed467429',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
    authorizationId: 'a34e8b1f-c397-4381-aac9-5558942b2aea',
    name: 'Skoda',
    dealerNo: 'SKD',
    isActive: false,
    isDefault: false,
    companyId: '7aafd041-f024-4550-876a-7b1bab2ff50c',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
  },
  {
    id: '9719fbcb-71a0-4948-9006-6e80a22cfd70',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
    authorizationId: '9c493262-e7b6-4e59-813c-7f2ab14030ed',
    name: 'MPT Other',
    isActive: false,
    isDefault: false,
    companyId: '7aafd041-f024-4550-876a-7b1bab2ff50c',
    companyAddressId: '0c2da4be-57ce-4c27-9af8-483bfc565ef3',
  },
  {
    id: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
    authorizationId: '1be1a4e7-e27f-4a4e-8592-01bada8b6428',
    name: 'Hyundai (Praha)',
    dealerNo: 'H0123',
    isActive: true,
    isDefault: false,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
  },
  {
    id: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
    authorizationId: '6fe94f62-5c09-4389-95f2-5c3dc10a52ea',
    name: 'Mercedes (Praha)',
    dealerNo: 'M100',
    isActive: true,
    isDefault: false,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
  },
  {
    id: '5e8b9314-ed1d-11ee-a951-0242ac120002',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
    authorizationId: 'f85088a6-ed22-11ee-a951-0242ac120002',
    name: 'Other (Bratislava)',
    isActive: true,
    isDefault: true,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: '0c2da4be-57ce-4c27-9af8-483bfc565ef3',
  },
  {
    id: '597601a2-ed1d-11ee-a951-0242ac120002',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
    authorizationId: 'e22f8d7a-e05b-11ee-bd3d-0242ac120002',
    name: 'Hyundai (Bratislava)',
    isActive: true,
    isDefault: false,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: '0c2da4be-57ce-4c27-9af8-483bfc565ef3',
  },
  {
    id: '88141214-fc4d-4459-8a1c-de076266391e',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '4865e2a6-664a-467a-91f8-24d58d2d7c6e',
    authorizationId: 'bfebeb48-0968-4aa8-ac7e-95883a45928c',
    name: 'Other (Warsaw)',
    isActive: true,
    isDefault: true,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: 'ad3e659a-3f87-4303-a8e4-c09a1514724b',
  },
  {
    id: '4e4e045a-ed1d-11ee-a951-0242ac120002',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '1f3d02fd-99dc-462f-9c12-9c5dd631cfa5',
    authorizationId: '1be1a4e7-e27f-4a4e-8592-01bada8b6428',
    name: 'Hyundai CZ',
    isActive: false,
    isDefault: false,
    companyId: '7aafd041-f024-4550-876a-7b1bab2ff50c',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
  },
  {
    id: 'e214dca0-5411-4b28-8918-f877c0cb22d2',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
    authorizationId: 'f85088a6-ed22-11ee-a951-0242ac120002',
    name: 'Test Profile',
    isActive: false,
    isDefault: false,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
  },
  {
    id: '4a73a044-a0d9-4482-b3ac-ffd0a2b75acb',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
    authorizationId: '763cd1f2-caed-4189-93c7-e3f5d5a88950',
    name: 'BMW',
    dealerNo: '[KrCz-01]',
    isActive: false,
    isDefault: false,
    companyId: '7aafd041-f024-4550-876a-7b1bab2ff50c',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
  },
  {
    id: '52573afb-b487-4b29-8a74-3173832afc59',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '259d9832-d79f-4102-abb7-a8fc43b21519',
    authorizationId: '6f574869-b22f-4046-847e-141e8ceadad4',
    name: 'Citroen',
    isActive: false,
    isDefault: false,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: '654bb1bb-7511-4cd8-8f7b-25a6e960de8e',
  },
  {
    id: 'ba4ec599-346d-4900-a9b5-85509bb6900f',
    tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
    authorizationId: '9c493262-e7b6-4e59-813c-7f2ab14030ed',
    name: 'Other (Praha)',
    isActive: true,
    isDefault: true,
    companyId: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
    validFrom: '2024-07-09T00:00:00Z',
    validUntil: '2024-07-30T00:00:00Z',
  },
];

const getAuthorizationProfilesResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/admin/v1/authorization-profiles*', () =>
      HttpResponse.json(getAuthorizationProfilesResponseMock)
    )
  );

const getAuthorizationProfileResponseMock: BaseAuthorizationProfile = {
  id: '55041578-ed1d-11ee-a951-0242ac120002',
  tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
  branchId: '1f3d02fd-99dc-462f-9c12-9c5dd631cfa5',
  authorizationId: '9c493262-e7b6-4e59-813c-7f2ab14030ed',
  name: 'Other',
  isDefault: false,
  isActive: false,
  companyId: '7aafd041-f024-4550-876a-7b1bab2ff50c',
  companyAddressId: '8c857562-862a-4ec1-b491-8854eb776089',
};

const getAuthorizationProfileResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get(`*/admin/v1/authorization-profile/*`, () =>
      HttpResponse.json(getAuthorizationProfileResponseMock)
    )
  );

export const metadaAdminAuthorizationProfileApiMock = {
  getAuthorizationProfilesResponseMock,
  getAuthorizationProfilesResponseInterceptor,
  getAuthorizationProfileResponseMock,
  getAuthorizationProfileResponseInterceptor,
};
